import SEO from "@/components/base/SEO";
import SchemaOrg from "@/components/base/SchemaOrg";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BreakingNews from "./components/BreakingNews";
import HotArticles from "./components/HotArticles";
import CategorySection from "./components/CategorySection";
import TrendingSidebar from "./components/TrendingSidebar";

export default function Home() {
  const pageTitle = "黑料吃瓜网 - 最新娱乐八卦热点聚合平台";
  const pageDesc = "黑料吃瓜网，汇聚娱乐圈最新黑料、明星八卦、热点事件与独家爆料。每日实时更新，让你第一时间吃到最劲爆的瓜，追踪娱乐圈内幕动态，尽在黑料吃瓜网。";
  const pageKeywords = "黑料吃瓜网,娱乐八卦黑料,明星黑料爆料,吃瓜热点事件,娱乐圈内幕,最新八卦新闻,明星丑闻追踪";

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl="https://heiliachigua.com"
        ogType="website"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          description: pageDesc,
          url: "https://heiliachigua.com",
          inLanguage: "zh-CN",
          isPartOf: {
            "@type": "WebSite",
            name: "黑料吃瓜网",
            url: "https://heiliachigua.com",
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <BreakingNews />

          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 min-w-0">
                <HotArticles />
              </div>
              <TrendingSidebar />
            </div>
          </div>

          <CategorySection />
        </main>
        <Footer />
      </div>
    </>
  );
}